<template>
    <Transition name="viewer">
        <div v-if="image" class="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4"
            @click.self="$emit('close')">
            <button type="button"
                class="absolute right-4 top-4 rounded-full p-2 text-white/80 transition-colors hover:bg-white/10 hover:text-white focus:outline-none focus:ring-2 focus:ring-white/50"
                aria-label="Close" @click="$emit('close')">
                <XMarkIcon class="h-8 w-8" />
            </button>
            <div class="viewer-image">
                <img :src="image" alt="" class="max-h-[90vh] max-w-full object-contain" @click.stop />
            </div>
        </div>
    </Transition>
</template>

<script setup>
import { XMarkIcon } from '@heroicons/vue/24/outline'

defineProps({
    image: {
        type: String,
        default: null
    }
})

defineEmits(['close'])
</script>

<style scoped>
.viewer-enter-active,
.viewer-leave-active {
    transition: opacity 0.25s ease;
}

.viewer-enter-active .viewer-image,
.viewer-leave-active .viewer-image {
    transition: transform 0.25s ease;
}

.viewer-enter-from,
.viewer-leave-to {
    opacity: 0;
}

.viewer-enter-from .viewer-image,
.viewer-leave-to .viewer-image {
    transform: scale(0.95);
}
</style>
